import React, { ReactNode } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { twMerge } from "tailwind-merge";
import { easeOut, shakeTransition, spring } from "../../utils/motion";
export type TileState = "idle" | "selected" | "correct" | "wrong" | "matched";
interface ChoiceTileProps {
  state: TileState;
  onClick: () => void;
  children: ReactNode;
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
  lang?: string;
}
const stateClass: Record<TileState, string> = {
  idle: "bg-surface text-ink shadow-brutal-sm",
  selected: "bg-brand-tint text-ink shadow-brutal",
  correct: "bg-good-tint text-ink shadow-brutal-sm",
  wrong: "bg-bad-tint text-ink shadow-brutal-sm",
  matched: "bg-good-tint text-ink"
};
export function ChoiceTile({
  state,
  onClick,
  children,
  disabled,
  className,
  ariaLabel,
  lang
}: ChoiceTileProps) {
  const reduce = useReducedMotion() ?? false;
  return <motion.button type="button" onClick={onClick} disabled={disabled || state === "matched"} aria-label={ariaLabel} aria-pressed={state === "selected"} lang={lang} animate={{
    x: state === "wrong" && !reduce ? [0, -8, 8, -6, 6, 0] : 0,
    y: state === "selected" && !reduce ? -3 : 0,
    scale: state === "correct" && !reduce ? [1, 1.05, 1] : state === "matched" ? 0.97 : 1,
    opacity: state === "matched" ? 0.5 : 1
  }} whileTap={disabled || state === "matched" ? undefined : {
    scale: 0.96
  }} transition={{
    x: shakeTransition,
    scale: state === "correct" ? {
      duration: 0.28,
      ease: easeOut
    } : spring.snappy,
    default: spring.snappy
  }} className={twMerge("focus-ring relative flex items-center justify-center rounded-card border-3 border-line px-4 py-3.5 text-center text-[16px] font-semibold transition-colors duration-150 disabled:cursor-default", stateClass[state], className)} data-id="element-292" data-mp="1gp16z5r2ts7e">
      {children}
    </motion.button>;
}